<template>
  <v-layout row wrap>
    <v-flex xs12 text-xs-center>
      <v-btn v-for="item in favcategories" :key="'cat__' + item.id" round outlined
        :class="selectedCategory === item.id ? 'selected-btn' : 'unselected-btn'" @click="selectCategory(item.id)">
        #{{ item.name }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'clubhouse-categories2',
  data() {
    return {
      selectedCategory: null
    }
  },
  computed: {
    favcategories() {
      return this.$store.getters['articles/favoritescategories']
    }
  },
  mounted() {
    // this.$store.dispatch('articles/ARTICLES_CATEGORIES').then(() => {
    //   const toolbox = this.categories.find(c => c.name.toLowerCase() === "toolbox")
    //   if (toolbox) {
    //     this.selectedCategory = toolbox.id
    //     this.$emit("category-selected", toolbox.id)
    //   }
    // })

    this.$store.dispatch('articles/ARTICLES_FAV_CATEGORIES').then(() => {
      // const toolbox = this.categories.find(c => c.name.toLowerCase() === "toolbox")
      const first = this.favcategories[0]
      if (first) {
        this.selectedCategory = first.id
        this.$emit("category-selected", first.id)
      }
    })
  },
  methods: {
    selectCategory(id) {
      this.selectedCategory = id
      this.$emit("category-selected", id);
    }
  }
}
</script>

<style scoped>
.selected-btn {
  background-color: #1e32fa !important;
  /* solid blue */
  color: white !important;
  border: 1px solid #1e32fa !important;
}


.unselected-btn {
  background-color: white !important;
  color: #1e32fa !important;
  border: 1px solid #1e32fa !important;
}
</style>



// WEBPACK FOOTER //
// src/views/app/clubhouse/share/clubhouse-categories2.vue